// We are replacing this with rollup
const packageVersion = "2.0.32";
const version = packageVersion === "0.0.0" ? "UNRELEASED" : packageVersion;

export { version };
//# sourceMappingURL=version.js.map
